import { createSlice } from "@reduxjs/toolkit";
import { getCustomerDetails, getCustomerMealPlans, getMealPlanDetail, getCustomerOrders, getOrderDetail, getCustomerBills, getBillDetail, getCustomerVerification } from "../Thunk/customerThunk";

const initialState = {
  isCustomerLoading: false,
  customerData: null,
  isMealPlansLoading: false,
  mealPlansData: null,
  isPlanDetailLoading: false,
  planDetailData: null,
  isOrdersLoading: false,
  ordersData: null,
  ordersMeta: null,
  isOrderDetailLoading: false,
  orderDetailData: null,
  isBillsLoading: false,
  billsData: null,
  isBillDetailLoading: false,
  billDetailData: null,
  isVerificationLoading: false,
  verificationData: null,
  error: null,
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    clearCustomerState: (state) => {
      state.customerData = null;
      state.mealPlansData = null;
      state.planDetailData = null;
      state.ordersData = null;
      state.ordersMeta = null;
      state.orderDetailData = null;
      state.billsData = null;
      state.billDetailData = null;
      state.verificationData = null;
      state.error = null;
      state.isCustomerLoading = false;
      state.isMealPlansLoading = false;
      state.isPlanDetailLoading = false;
      state.isOrdersLoading = false;
      state.isOrderDetailLoading = false;
      state.isBillsLoading = false;
      state.isBillDetailLoading = false;
      state.isVerificationLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerDetails.pending, (state) => {
        state.isCustomerLoading = true;
        state.error = null;
      })
      .addCase(getCustomerDetails.fulfilled, (state, action) => {
        state.isCustomerLoading = false;
        state.customerData = action.payload?.data || null;
      })
      .addCase(getCustomerDetails.rejected, (state, action) => {
        state.isCustomerLoading = false;
        state.error = action.payload || "Failed to fetch customer details";
      })
      .addCase(getCustomerMealPlans.pending, (state) => {
        state.isMealPlansLoading = true;
        state.error = null;
      })
      .addCase(getCustomerMealPlans.fulfilled, (state, action) => {
        state.isMealPlansLoading = false;
        state.mealPlansData = action.payload?.data?.meal_plans || [];
      })
      .addCase(getCustomerMealPlans.rejected, (state, action) => {
        state.isMealPlansLoading = false;
        state.error = action.payload || "Failed to fetch customer meal plans";
      })
      .addCase(getMealPlanDetail.pending, (state) => {
        state.isPlanDetailLoading = true;
        state.error = null;
      })
      .addCase(getMealPlanDetail.fulfilled, (state, action) => {
        state.isPlanDetailLoading = false;
        state.planDetailData = action.payload?.data || null;
      })
      .addCase(getMealPlanDetail.rejected, (state, action) => {
        state.isPlanDetailLoading = false;
        state.error = action.payload || "Failed to fetch meal plan detail";
      })
      .addCase(getCustomerOrders.pending, (state) => {
        state.isOrdersLoading = true;
        state.error = null;
      })
      .addCase(getCustomerOrders.fulfilled, (state, action) => {
        state.isOrdersLoading = false;
        state.ordersData = action.payload?.data?.orders || [];
        state.ordersMeta = action.payload?.data ? {
          total: action.payload.data.total || 0,
          currentPage: action.payload.data.current_page || 1,
          lastPage: action.payload.data.last_page || 1,
          perPage: action.payload.data.per_page || 15
        } : null;
      })
      .addCase(getCustomerOrders.rejected, (state, action) => {
        state.isOrdersLoading = false;
        state.error = action.payload || "Failed to fetch customer orders";
      })
      .addCase(getOrderDetail.pending, (state) => {
        state.isOrderDetailLoading = true;
        state.error = null;
      })
      .addCase(getOrderDetail.fulfilled, (state, action) => {
        state.isOrderDetailLoading = false;
        state.orderDetailData = action.payload?.data || null;
      })
      .addCase(getOrderDetail.rejected, (state, action) => {
        state.isOrderDetailLoading = false;
        state.error = action.payload || "Failed to fetch order detail";
      })
      .addCase(getCustomerBills.pending, (state) => {
        state.isBillsLoading = true;
        state.error = null;
      })
      .addCase(getCustomerBills.fulfilled, (state, action) => {
        state.isBillsLoading = false;
        state.billsData = action.payload?.data?.bills || [];
      })
      .addCase(getCustomerBills.rejected, (state, action) => {
        state.isBillsLoading = false;
        state.error = action.payload || "Failed to fetch customer bills";
      })
      .addCase(getBillDetail.pending, (state) => {
        state.isBillDetailLoading = true;
        state.error = null;
      })
      .addCase(getBillDetail.fulfilled, (state, action) => {
        state.isBillDetailLoading = false;
        state.billDetailData = action.payload?.data || null;
      })
      .addCase(getBillDetail.rejected, (state, action) => {
        state.isBillDetailLoading = false;
        state.error = action.payload || "Failed to fetch bill detail";
      })
      .addCase(getCustomerVerification.pending, (state) => {
        state.isVerificationLoading = true;
        state.error = null;
      })
      .addCase(getCustomerVerification.fulfilled, (state, action) => {
        state.isVerificationLoading = false;
        state.verificationData = action.payload?.data || null;
      })
      .addCase(getCustomerVerification.rejected, (state, action) => {
        state.isVerificationLoading = false;
        state.error = action.payload || "Failed to fetch customer verification status";
      });
  },
});

export const { clearCustomerState } = customerSlice.actions;
export default customerSlice.reducer;
